var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-page-container"},[_c('c-header-component'),_c('c-main-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }